import { render, staticRenderFns } from "./Dictamen.vue?vue&type=template&id=6e577d32&scoped=true"
import script from "./Dictamen.vue?vue&type=script&lang=js"
export * from "./Dictamen.vue?vue&type=script&lang=js"
import style0 from "./Dictamen.vue?vue&type=style&index=0&id=6e577d32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e577d32",
  null
  
)

export default component.exports